import type { PublicCorrectionCard as Correction } from '../../lib/manualCorrectionsApi';

const STATUS_COPY: Record<Correction['status'], { label: string; className: string }> = {
  PENDING: {
    label: 'Создана, ждёт обработки',
    className: 'border-primary/40 bg-primary/10 text-foreground',
  },
  APPROVED_AWAITING_RECALC: {
    label: 'Одобрена, ожидает штатного пересчёта',
    className: 'border-success/50 bg-success/10 text-foreground',
  },
  REJECTED: {
    label: 'Отказано',
    className: 'border-destructive/50 bg-destructive/10 text-foreground',
  },
};

const Participant = ({ label, name, squad }: { label: string; name: string; squad: string }) => (
  <div>
    <dt className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">{label}</dt>
    <dd className="mt-1 break-words font-medium">
      {name}
      {squad ? <> <span className="text-muted-foreground">[{squad}]</span></> : null}
    </dd>
  </div>
);

export function ManualCorrectionCard({
  correction,
  onOpen,
}: {
  correction: Correction;
  onOpen?: (publicId: string) => void;
}): JSX.Element {
  const status = STATUS_COPY[correction.status];

  return (
    <article className="rounded-lg border border-border bg-card p-4 shadow-sm">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <p className="text-xs text-muted-foreground">Заявка</p>
          {onOpen ? (
            <button
              type="button"
              className="break-all text-left font-mono text-sm font-semibold underline decoration-primary/50 underline-offset-4 hover:text-primary"
              onClick={() => onOpen(correction.public_id)}
            >
              {correction.public_id}
            </button>
          ) : (
            <p className="break-all font-mono text-sm font-semibold">{correction.public_id}</p>
          )}
        </div>
        <span className={`rounded-md border px-2.5 py-1 text-xs font-semibold ${status.className}`}>
          {status.label}
        </span>
      </div>

      <dl className="mt-4 grid gap-3 sm:grid-cols-2">
        <div>
          <dt className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">Бой и реплей</dt>
          <dd className="mt-1 break-words font-medium">
            {correction.game_date} · {correction.replay_name}
          </dd>
        </div>
        <Participant
          label="Автор фрага"
          name={correction.claimed_killer_name}
          squad={correction.claimed_killer_squad}
        />
        <Participant
          label="Жертва"
          name={correction.claimed_victim_name}
          squad={correction.claimed_victim_squad}
        />
      </dl>

      {correction.status === 'REJECTED' && correction.public_rejection_reason ? (
        <div className="mt-4 rounded-md border border-destructive/30 bg-destructive/5 p-3">
          <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">Причина отказа</p>
          <p className="mt-1 whitespace-pre-wrap break-words text-sm">{correction.public_rejection_reason}</p>
        </div>
      ) : null}
    </article>
  );
}
